export default {
  query: minWidth => `@media only screen and (min-width: ${minWidth}px)`,
  maxQuery: maxWidth => `@media only screen and (max-width: ${maxWidth}px)`,
  tabletMin: 530,
  bigTabletMin: 768,
  desktopMin: 1000,
  fullMin: 1450,
};
